import React, { useEffect, useState } from 'react';
import retrieve_warehouse_storages_list_Slice from '../../../../../../../../reducers/dashboard_reducers/warehouse/retrieve_warehouse_storages_list_Slice';
import { useDispatch } from 'react-redux';
import { Alert, Card, CardTitle, Spinner } from 'reactstrap';
import { Button, Col, Icon } from '../../../../../../../../components/Component';
import ReadOnlyTable from '../../../../../table/ReadOnlyTable';
import * as app_consts from "../../../../../../../../constants/react_app_consts";
import ModalAdd from '../../../../../modal/modal_add/ModalAdd';
import { employee_dashboard_actions_helper } from '../../../../../../../../actions/actions_helper';
import { fail_complete_adding_goods_received_products, loading_complete_adding_goods_received_products, reset_complete_adding_goods_received_products, success_complete_adding_goods_received_products } from '../../../../../../../../reducers/dashboard_reducers/goods_received/complete_adding_goods_received_products_Slice';
import { COMPLETE_ADDING_GOODS_RECEIVED_NOTE_PRODUCTS_API } from '../../../../../../../../api/api_data';
import { COMPLETE_ADDING_GOODS_RECEIVED_NOTE_PRODUCTS_ACCESS_DENIED_MSG, COMPLETE_ADDING_GOODS_RECEIVED_NOTE_PRODUCTS_ERR_MSG, COMPLETE_ADDING_GOODS_RECEIVED_NOTE_PRODUCTS_SUCCESS_MSG } from '../../../../../../../../constants/success_error_messages_consts';
import { messageToast } from '../../../../../../../../utils/Utils';
import { useParams } from 'react-router';
import { useSelector } from 'react-redux';

const type = app_consts.ADD_PRODUCTS_TO_GOODS_RECEIVED_NOTE_TICKET;
const goods_received_product_type = app_consts.GOODS_RECEIVED_PRODUCTS_LIST;

const resolveGoodsReceivedId = (continueProcessingData = {}, weighBridgeData = {}) => {
    const candidates = [
        continueProcessingData?.goods_received_id,
        continueProcessingData?.goods_received?.goods_received_id,
        continueProcessingData?.goods_reeived_data?.goods_received_id,
        weighBridgeData?.goods_received_id,
        weighBridgeData?.goods_received?.goods_received_id,
        weighBridgeData?.goods_reeived_data?.goods_received_id,
    ];

    return candidates.find((value) => value !== null && value !== undefined && value !== "") || "";
};

const resolveGoodsReceivedRefNumber = (continueProcessingData = {}, weighBridgeData = {}) => {
    const candidates = [
        continueProcessingData?.goods_received_ref_number,
        continueProcessingData?.goods_received?.goods_received_ref_number,
        continueProcessingData?.goods_reeived_data?.goods_received_ref_number,
        weighBridgeData?.goods_received_ref_number,
        weighBridgeData?.goods_received?.goods_received_ref_number,
        weighBridgeData?.goods_reeived_data?.goods_received_ref_number,
    ];

    return candidates.find((value) => value !== null && value !== undefined && value !== "") || "";
};

const ProductsReceivedStep = ({
    weighBridgeFormData,
    setWeighBridgeFormData,
    continue_processing_data,
    setContinueProcessingData,
    prevStep,
    nextStep
}) => {

    const { goods_received_ref_number } = useParams();

    const [errorVal, setErrorVal] = useState("");
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState(weighBridgeFormData);
    const [stepData, setStepData] = useState([]);
    const dispatch = useDispatch();
    const [refData, setRefData] = useState([]);
    const [openPreview, setOpenPreview] = useState(false);
    const [product_data, setproductData] = useState([]);
    const [page_data, setPageData] = useState(continue_processing_data);
    const [openAddProductsModal, setOpenAddProductsModel] = useState(false);
    const [total_mt_capacity, setTotalMTCapacity] = useState(0);
    const goodsReceivedId = resolveGoodsReceivedId(continue_processing_data, weighBridgeFormData);
    const goodsReceivedRefNumber = resolveGoodsReceivedRefNumber(continue_processing_data, weighBridgeFormData);

    // ======================================================
    // WEIGHBRIDGE INTEGRATION ADDITION (SAFE)
    // Lock product editing when ticket-driven GRN is selected
    // This does not affect the normal flow (when not locked)
    // ======================================================
    const isWeighbridgeLocked = !!weighBridgeFormData?.weighbridge_locked;

    // Add product Modal
    const openPropertyModal = () => {
        // ======================================================
        // WEIGHBRIDGE INTEGRATION ADDITION (SAFE)
        // Prevent opening modal when locked
        // ======================================================
        if (isWeighbridgeLocked) return;

        setOpenAddProductsModel(true);
    };

    useEffect(() => {
        setFormData(weighBridgeFormData);
        setRefData(continue_processing_data);
        if (continue_processing_data)
        {
            setStepData({ ...stepData, ["weigh_bridge_ticket_number"]: continue_processing_data?.weigh_bridge_ticket_number });
            if (continue_processing_data?.goods_received_products)
            {
                setproductData(continue_processing_data?.goods_received_products);
            }
        }
    }, [weighBridgeFormData, continue_processing_data]);

    const successAddFunc = (added_data) => {
        setproductData([...product_data, added_data]);
        setWeighBridgeFormData((prev) => ({
            ...prev,
            goods_received_products: [...product_data, added_data],
        }));
        setContinueProcessingData((prev) => ({
            ...prev,
            goods_received_products: [...product_data, added_data],
        }));
        setOpenAddProductsModel(false);
    };

    const previousStep = () => {
        setWeighBridgeFormData((prev) => ({
            ...prev,
            goods_received_products: product_data,
        }));
        setContinueProcessingData((prev) => ({
            ...prev,
            goods_received_products: product_data,
        }));
        prevStep();
    };

    const finish_adding_products = () => {
        const completeProductsPayload = {
            goods_received_id: goodsReceivedId,
            goods_received_ref_number: goodsReceivedRefNumber,
            first_weight:
                weighBridgeFormData?.first_weight ||
                continue_processing_data?.first_weight ||
                "",
            second_weight:
                weighBridgeFormData?.second_weight ||
                continue_processing_data?.second_weight ||
                "",
            net_weight:
                weighBridgeFormData?.net_weight ||
                continue_processing_data?.net_weight ||
                "",
        };

        console.log("COMPLETE GOODS RECEIVED PRODUCTS PAYLOAD =>", completeProductsPayload);
        console.log("COMPLETE GOODS RECEIVED PRODUCTS CONTINUE DATA =>", continue_processing_data);
        console.log("COMPLETE GOODS RECEIVED PRODUCTS FORM DATA =>", weighBridgeFormData);
        console.log("COMPLETE GOODS RECEIVED PRODUCTS TABLE DATA =>", product_data);

        dispatch(
            employee_dashboard_actions_helper(
                loading_complete_adding_goods_received_products,
                success_complete_adding_goods_received_products,
                fail_complete_adding_goods_received_products,
                COMPLETE_ADDING_GOODS_RECEIVED_NOTE_PRODUCTS_ERR_MSG,
                COMPLETE_ADDING_GOODS_RECEIVED_NOTE_PRODUCTS_SUCCESS_MSG,
                app_consts.POST,
                COMPLETE_ADDING_GOODS_RECEIVED_NOTE_PRODUCTS_API,
                completeProductsPayload,
                COMPLETE_ADDING_GOODS_RECEIVED_NOTE_PRODUCTS_ACCESS_DENIED_MSG
            )
        );
    };

    const complete_adding_grn_products = useSelector((state) => state.complete_adding_goods_received_products.complete_adding_goods_received_products);

    useEffect(() => {
        if (complete_adding_grn_products.status !== app_consts.IDLE)
        {
            if (complete_adding_grn_products.status === app_consts.LOADING)
            {
                setErrorVal("");
                setLoading(true);
            } else
            {
                setLoading(false);
                if (complete_adding_grn_products.status === app_consts.FAIL)
                {
                    console.log("COMPLETE GOODS RECEIVED PRODUCTS FAILURE =>", complete_adding_grn_products);
                    setErrorVal(complete_adding_grn_products.message);
                    messageToast(complete_adding_grn_products.message, app_consts.FAIL);
                } else if (complete_adding_grn_products.status === app_consts.SUCCESS)
                {
                    console.log("COMPLETE GOODS RECEIVED PRODUCTS SUCCESS =>", complete_adding_grn_products);
                    messageToast(COMPLETE_ADDING_GOODS_RECEIVED_NOTE_PRODUCTS_SUCCESS_MSG, app_consts.SUCCESS);
                    setWeighBridgeFormData({ ...complete_adding_grn_products.data?.goods_reeived_data, ["user_account_label"]: complete_adding_grn_products.data?.user_account });
                    nextStep();
                }
                dispatch(reset_complete_adding_goods_received_products());
            }
        }
    }, [complete_adding_grn_products]);

    // Get Sum of all Goods Received Products
    const totalCapacitySum = product_data?.reduce((sum, item) => {
        return sum + parseFloat(item?.total_capacity_in_mt);
    }, 0);

    useEffect(() => {
        setTotalMTCapacity(totalCapacitySum);
    }, [product_data]);

    return (
        <>
            <Card className="card-inner">
                <CardTitle tag="h5">Products Received Details</CardTitle>
                <Col lg="12">
                    <div className="form-group d-flex justify-between">
                        <div>
                            {weighBridgeFormData.consigner_type_id === app_consts.UAG_CONSIGNER_TYPE ? (
                                <>
                                    <div className="form-label-group">
                                        <label className="form-label text-soft">User Account ID :</label>
                                    </div>
                                    <div className="form-control-wrap">
                                        <label className="form-label text-primary">UAG</label>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="form-label-group">
                                        <label className="form-label text-soft">User Account ID :</label>
                                    </div>
                                    <div className="form-control-wrap">
                                        <label className="form-label text-primary">{weighBridgeFormData.user_account_label}</label>
                                    </div>
                                </>
                            )}
                        </div>
                        <div>
                            <div className="form-label-group">
                                <label className="form-label text-soft">Total Capacity In MT :</label>
                            </div>
                            <div className="form-control-wrap">
                                <label className="form-label text-primary">{total_mt_capacity ? parseFloat(total_mt_capacity)?.toFixed(2) : "0.00"}</label>
                            </div>
                        </div>
                    </div>
                </Col>

                <Col xl="12" className="mb-3 mt-3">
                    <div className="form-group">
                        <div className="form-control-wrap-flex-wrap justify-start">
                            <Button
                                onClick={openPropertyModal}
                                className="btn btn-dim btn-outline-primary"
                                size="md"
                                // ======================================================
                                // WEIGHBRIDGE INTEGRATION ADDITION (SAFE)
                                // Disable manual add when locked
                                // ======================================================
                                disabled={isWeighbridgeLocked}
                            >
                                Add Product
                            </Button>
                        </div>

                        {
                            isWeighbridgeLocked ? (
                                <div className="text-soft mt-2">
                                    Products are locked because this ticket is linked to a weighbridge record.
                                </div>
                            ) : null
                        }
                    </div>
                </Col>

                {/* Table */}
                <div className="my-3">
                    <ReadOnlyTable data={product_data} tableType={goods_received_product_type} />
                </div>

                <hr />

                {errorVal && (
                    <div className="mt-4">
                        <Alert color="danger" className="alert-icon">
                            {" "}
                            <Icon name="alert-circle" />
                            {errorVal}{" "}
                        </Alert>
                    </div>
                )}

                <Col xl="12">
                    <div className="form-group mt-2">
                        <div className="form-control-wrap-flex-wrap justify-between items-center">
                            <Button
                                onClick={previousStep}
                                className="btn btn-dim btn-outline-primary"
                                size="md"
                            >
                                Go to Previous Step
                            </Button>
                            <Button
                                onClick={finish_adding_products}
                                disabled={
                                    loading
                                        ? loading
                                        : !(product_data?.length > 0)
                                }
                                color="primary"
                                size="md"
                            >
                                {loading ? <Spinner size="sm" color="light" /> : "Finish Adding Products "}
                            </Button>
                        </div>
                    </div>
                </Col>

                <hr />
            </Card>

            <ModalAdd
                openModal={openAddProductsModal}
                setOpenModal={setOpenAddProductsModel}
                modalTitle="Add Goods Received Note Products"
                modalDescription="Please Complete this form to Add Product to DGoods Received Note Ticket"
                type={type}
                succFunc={successAddFunc}
                accountId={{ continue_processing_data, weighBridgeFormData }}
            />
        </>
    );
};

export default ProductsReceivedStep;
